import React, { useState } from "react";
import style from "./Testimonials.module.css";
import { FaArrowRight as RightAr, FaArrowLeft as LeftAr } from "react-icons/fa";
import cx from "classnames";
export default function Testimonials() {
  const [slideIndex, setSlideIndex] = useState(0);

  const initState = [
    {
      data: (
        <div className={style.slidesMain}>
          <img
            alt="CEO_PIC"
            src="https://invozone.com/wp-content/uploads/2020/04/Ron_Ramanan.svg"
            className={style.slideFig}
          ></img>
          <p className={style.slideDescription}>
            This team at InvoZone is really something, in my opinion. We wanted
            something and they delivered it without any second guesses. The
            workflow is so smooth, I really enjoyed my time.
          </p>
          <p className={style.name}>Ron Ramanan</p>
          <p className={style.company}>CEO Travlytix</p>
        </div>
      ),
    },
    {
      data: (
        <div className={style.slidesMain}>
          <img
            alt="CEO_PIC"
            src="https://invozone.com/wp-content/uploads/2020/04/Derek_Morin.svg"
            className={style.slideFig}
          ></img>
          <p className={style.slideDescription}>
            InvoZone had the three main qualities we’re looking for in
            developers: Communicative and timely, Availability, Spot-on Coding.
            If I could give a Top 1% badge to InvoZone people, I would. Thank
            you!
          </p>
          <p className={style.name}>Derek Morin</p>
          <p className={style.company}>CEO Tabarnapp</p>
        </div>
      ),
    },
    {
      data: (
        <div className={style.slidesMain}>
          <img
            alt="CEO_PIC"
            src="https://invozone.com/wp-content/uploads/2020/04/Mucteba_Celik.svg"
            className={style.slideFig}
          ></img>
          <p className={style.slideDescription}>
            Extraordinary! It has been an honour to work with InvoZone. They
            possess awesome development skills and give great attention to
            minute detail. For me, one of the most capable companies.
          </p>
          <p className={style.name}>Mucteba Celik</p>
          <p className={style.company}>CTO Revbits</p>
        </div>
      ),
    },
  ];
  const slideDiv = initState;

  const changeSlide = n => {
    setSlideIndex(n);
  };

  const moveForward = n => {
    if (slideIndex + n <= 2 && slideIndex + n >= 0) {
      changeSlide(slideIndex + n);
    } else if (slideIndex + n > 2) {
      changeSlide(0);
    } else if (slideIndex + n < 0) {
      changeSlide(2);
    }
  };
  return (
    <div className={style.mainContainer}>
      <div className={style.innerContainer}>
        <div className={style.leftContainer}>
          <div className={style.leftInner}>
            <h1 className={style.heading}>
              CLIENT <strong> TESTIMONIALS</strong>
            </h1>
            <p className={style.description}>
              We make sure that our clients leave with a smile and a feeling of
              accomplishment. Take a look at what some of them have to say about
              us!
            </p>
            <div className={style.btnsContainer}>
              <button
                className={style.navigationBtn}
                onClick={() => moveForward(-1)}
              >
                <LeftAr />
              </button>
              <button
                className={style.navigationBtn}
                onClick={() => moveForward(1)}
              >
                <RightAr />
              </button>
            </div>
          </div>
        </div>
        <div className={style.rightContainer}>
          <div className={style.quoteImg}>
            <img
              alt="quote"
              src="https://invozone.com/wp-content/uploads/2020/04/testimonial-arrow.png"
              className={style.quoteFig}
            ></img>
          </div>
          <div className={style.slideShowContainer}>
            <div className={style.innerSlidesContainer}>
              {slideDiv[slideIndex].data}
              <div className={style.dotsDiv}>
                <span
                  id="dot"
                  className={cx(
                    style.dot,
                    slideIndex === 0 ? style.active : ""
                  )}
                  onClick={e => changeSlide(0)}
                ></span>
                <span
                  id="dot"
                  className={cx(
                    style.dot,
                    slideIndex === 1 ? style.active : ""
                  )}
                  onClick={e => changeSlide(1)}
                ></span>
                <span
                  id="dot"
                  className={cx(
                    style.dot,
                    slideIndex === 2 ? style.active : ""
                  )}
                  onClick={e => changeSlide(2)}
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
